// ======================================================
// MOVIEFRENZY — SUPERSTAR REGISTRY
//
// mode:
// "auto"      = le moteur /100 décide
// "force-on"  = MovieFrenzy impose Superstar
// "force-off" = MovieFrenzy refuse Superstar
// ======================================================

const DEFAULT_SUPERSTAR_PROFILE = {
    mode: "auto",
    prestige: 0,
    legacy: false,
    editorialOverride: false,
    regionalIcon: false,
    featuredMovieIds: [],
};

export const SUPERSTAR_REGISTRY = {

    // Charlie Chaplin
    // Reconnaissance éditoriale du patrimoine cinématographique.
    // Sa qualification historique ne dépend pas de films récents.
    13848: {
        mode: "auto",
        prestige: 20,
        legacy: true,
        editorialOverride: false,
        regionalIcon: false,
        featuredMovieIds: [],
    },

    // Tom Holland
    1136406: {
        mode: "auto",
        prestige: 10,
        legacy: false,
        editorialOverride: false,

        featuredMovieIds: [
            271110,
            315635,
            299536,
            299534,
            429617,
            634649,
            335787,
            508439,
        ],
    },

    // Bruce Willis
    // Icône majeure dont l'activité récente
    // ne doit pas détruire le statut historique.
    62: {
        mode: "auto",
        prestige: 20,
        legacy: true,
        editorialOverride: false,
        featuredMovieIds: [],
    },
    // Roy Dupuis
    // Reconnaissance éditoriale MovieFrenzy :
    // icône régionale québécoise.
    56977: {
        mode: "auto",
        prestige: 0,
        legacy: false,
        editorialOverride: false,
        regionalIcon: true,
        regionalScope: "quebec",
        featuredMovieIds: [],
    },
    // Karine Vanasse
    // Reconnaissance éditoriale MovieFrenzy :
    // icône de la sphère québécoise.
    81418: {
        mode: "auto",
        prestige: 0,
        legacy: false,
        editorialOverride: false,
        regionalIcon: true,
        regionalScope: "quebec",
        featuredMovieIds: [],
    },
    // Rémy Girard
    // Reconnaissance éditoriale MovieFrenzy :
    // icône de la sphère québécoise.
    38526: {
        mode: "auto",
        prestige: 0,
        legacy: false,
        editorialOverride: false,
        regionalIcon: true,
        regionalScope: "quebec",
        featuredMovieIds: [],
    },
    // Luc Picard
    // Reconnaissance éditoriale MovieFrenzy :
    // icône de la sphère québécoise.
    95956: {
        mode: "auto",
        prestige: 0,
        legacy: false,
        editorialOverride: false,
        regionalIcon: true,
        regionalScope: "quebec",
        featuredMovieIds: [],
    },
    // Zendaya
    // Exemple de veto éditorial MovieFrenzy.
    505710: {
        mode: "force-off",
        prestige: 0,
        legacy: false,
        editorialOverride: false,
        featuredMovieIds: [],
    },
};

export const getSuperStarProfile = (actorId) => {
    return (
        SUPERSTAR_REGISTRY[Number(actorId)] ||
        DEFAULT_SUPERSTAR_PROFILE
    );
};